module.exports = __webpack_public_path__ + "img/refund_icon.fd8d2399.svg";